import {updateObject} from "../../shared/utils/utils";
import * as actionTypes from "./actionTypes";

const initialState = {
    companies: {
        data: [],
        page: 0,
        rowsPerPage: 10,
        count: 0,
        loading: false
    },
    deleteDialog: {
        loading: false,
        userCount: null
    },
    suggestedCompanies: [],
    selectedCompany: "",
}

const setCompanies = (state, action) => {
    return updateObject(state, {
        companies: updateObject(state.companies, {
            data: action.payload.data,
            page: action.page,
            rowsPerPage: action.rowsPerPage,
            count: action.payload.count
        })
    })
}

const setFieldCompanies = (state, action) => {
    return updateObject(state, {companies: updateObject(state.companies, {[action.typeOf]: action.payload})})
}

const setDeleteDialogLoading = (state, action) => {
    return updateObject(state, {deleteDialog: updateObject(state.deleteDialog, {loading: action.value})})
}

const setUserCountForCompany = (state, action) => {
    return updateObject(state, {deleteDialog: updateObject(state.deleteDialog, {userCount: action.usersCount})})
}

const setCompaniesForSelect = (state, action) => {
    return updateObject(state, {suggestedCompanies: action.data})
}

export const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.FETCH_COMPANIES_SUCCESS:
            return setCompanies(state, action);
        case actionTypes.SET_COMPANIES_FIELD:
            return setFieldCompanies(state, action);
        case actionTypes.SET_COMPANY_DELETE_DIALOG_LOADING:
            return setDeleteDialogLoading(state, action);
        case actionTypes.SET_NUMBER_OF_USERS_FOR_COMPANY:
            return setUserCountForCompany(state, action);
        case actionTypes.FETCH_COMPANIES_FOR_SELECT:
            return setCompaniesForSelect(state, action);
        default:
            return state;
    }
}
